// src/pages/Donate.js

import React from 'react';
import { Link } from 'react-router-dom';
import '../App.css';

const Donate = () => {
  return (
    <div className="main">
      <div className="column1"></div>
      <div className="column2">
        <div style={{ textAlign: 'center', margin: '2em 0' }}>
          <h1>Donate</h1>
        </div>
        <p>
          Sabrenetics relies on voluntary contributions, tips, and donations to keep our website and services operational and to advance our mission in biomedical engineering and cybernetics.
        </p>
        <h3>Transparency</h3>
        <ul>
          <li>We do <strong>not</strong> represent a charity.</li>
          <li>Donations are <strong>not</strong> tax-deductible.</li>
          <li>We are a private organization, not a registered charity or nonprofit.</li>
          <li>Funds are used to maintain our website, community programs, and research initiatives.</li>
        </ul>
        <h3>Bank Transfer Details</h3>
        <li>Account Name: Sabrenetics</li>
        <li>Bank: Commonwealth Bank of Australia</li>
        <li>BSB: 062-199</li>
        <li>Account Number: 10812493</li>
        <h3>In-Kind & Museum Donations</h3>
        <p>
          We welcome donations of physical items related to biomedical engineering, cybernetics, cyberware, or cyborg history for our museum. Donated artifacts will be displayed with a plaque bearing your name, publicly viewable indefinitely in our permanent collection.
        </p>
        <p>
          Questions or alternative donation methods? <Link to="/contactus">Contact us</Link>.
        </p>
      </div>
      <div className="column3"></div>
    </div>
  );
};

export default Donate;
